import { createFailedUploadOutcome } from '../../../../../Services/candidateFileUpload';

export const createChecklistUploadOutcome = ({ clientOperationId, file, isCandidatePhoto, replacementStatus }) => {
  return createFailedUploadOutcome({
    clientOperationId,
    file,
    isProfilePhoto: isCandidatePhoto,
    replacementStatus,
  });
};
